import React from 'react';
import DynamicSidebar from './DynamicSidebar';

const Sidebar = ({ userRole, user, onNavigate, activeItem, onLogout, isCollapsed = false, expandedItems, onToggleExpanded }) => {
  return (
    <div className={`bg-white border-r border-gray-200 transition-all duration-300 h-screen overflow-hidden ${isCollapsed ? 'w-16' : 'w-80'
      }`}>
      <DynamicSidebar
        userRole={userRole}
        user={user}
        onNavigate={onNavigate}
        activeItem={activeItem}
        onLogout={onLogout}
        expandedItems={expandedItems}
        onToggleExpanded={onToggleExpanded}
      />
    </div>
  );
};

export default Sidebar;
